import fetchApi from '@/lib/tools/api'
import {UserProducer} from '@/types'
import {Box, Button} from '@mui/material'
import React, {useCallback} from 'react'
import {useListContext, useNotify, useRecordContext, useRefresh, useUnselectAll} from 'react-admin'

interface UnlinkProducersResponse {
	success: boolean
	unlinkedCount: number
	user: UserProducer
}

export default function LinkedProducersBulkActions() {

	const {selectedIds} = useListContext()
	const record = useRecordContext<UserProducer>()
	const unselectAll = useUnselectAll(`producers/users.${record.id}.producers`)
	const refresh = useRefresh()
	const notify = useNotify()

	const unlink = useCallback(async () => {
		try {
			const response = await fetchApi<UnlinkProducersResponse>(
				`/producers/users/${record.id}/unlink-producers`,
				{producerIds: selectedIds},
				null,
				'POST'
			)

			if (response.success) {
				unselectAll()
				refresh()
				notify(`${response.unlinkedCount} entreprise(s) déliée(s) avec succès`, {type: 'success'})
			}
		} catch (error) {
			notify('Erreur lors de la déliaison des entreprises', {type: 'error'})
			console.error(error)
		}
	}, [selectedIds, record.id, unselectAll, refresh, notify])


	return (
		<Box>
			<Button onClick={unlink} variant="contained" color="error">Délier la sélection</Button>
		</Box>
	)
}
